import { Action } from "redux";
import { ThunkAction } from "redux-thunk";

import { RootState } from "app/redux/reducer";
import { showMessage, toggleLoader } from "app/redux/system/actions";
import { initialPageData } from "app/redux/page/actions";
import { MessageType } from 'app/redux/system/types';
import { HttpStatusCode, IListFilter } from "app/shared";
import { setSpecifications, setSpecificationTypes } from "app/redux/specification/actions";

import SpecificationService from "./service";
import { mapSpecificationFromEntity, mapSpecificationFromModel, mapSpecificationTypeFromEntity, mapSpecificationTypeFromModel } from "./mapping";
import { ISpecification, ISpecificationType } from "./types";

type ThunkResult<R> = ThunkAction<R, RootState, {}, Action>;

export function getSpecification(specificationId: string): ThunkResult<Promise<any>> {
    return async (dispatch, getState) => {
        const service = new SpecificationService();
        dispatch(toggleLoader());
        const response = await service.getSpecification(specificationId);
        dispatch(toggleLoader());
        if (response.status === HttpStatusCode.OK) {
            const mapped = mapSpecificationFromEntity(response.data.attributes["specification"] || {});
            dispatch(initialPageData<ISpecification>(mapped));
            return true;
        }
        dispatch(showMessage("Bir hata oluştu. Servis sağlayıcınızla iletişime geçin ya da daha sonra tekrar deneyiniz!", "Bir Hata Oluştu!", MessageType.ERROR))
        return false;
    };
}

export function getSpecifications(options: IListFilter): ThunkResult<Promise<boolean>> {
    return async (dispatch, getState) => {
        const service = new SpecificationService();
        dispatch(toggleLoader());
        const response = await service.getSpecifications(options);
        dispatch(toggleLoader());
        if (response.status === HttpStatusCode.OK) {
            const mapped = (response?.data?.attributes?.list || []).map((item) =>
                mapSpecificationFromEntity(item)
            );
            dispatch(setSpecifications({
                list: mapped,
                pageSize: response.data.attributes.pageSize,
                totalCount: response.data.attributes.total,
                pageCount: Math.ceil(response.data.attributes.total / response.data.attributes.pageSize)
            }));
            return true;
        }
        return false;
    };
}

export function createSpecification(request: ISpecification): ThunkResult<Promise<ISpecification | null>> {
    return async (dispatch, getState) => {
        const service = new SpecificationService();
        dispatch(toggleLoader());
        const response = await service.createSpecification(mapSpecificationFromModel(request));
        dispatch(toggleLoader());
        if (response.status === HttpStatusCode.OK) {
            return mapSpecificationFromEntity(response.data.attributes["specification"] || {});
        }
        return null;
    };
}

export function updateSpecification(request: ISpecification): ThunkResult<Promise<boolean>> {
    return async (dispatch, getState) => {
        const service = new SpecificationService();
        dispatch(toggleLoader());
        const response = await service.updateSpecification(mapSpecificationFromModel(request));
        dispatch(toggleLoader());
        if (response.status === HttpStatusCode.OK) {
            return true;
        }
        return false;
    };
}

export function deleteSpecification(specificationId: string): ThunkResult<Promise<boolean>> {
    return async (dispatch, getState) => {
        const service = new SpecificationService();
        dispatch(toggleLoader());
        const response = await service.deleteSpecification(specificationId);
        dispatch(toggleLoader());
        if (response.status === HttpStatusCode.OK) {
            return true;
        }
        dispatch(showMessage("Bir hata oluştu. Servis sağlayıcınızla iletişime geçin ya da daha sonra tekrar deneyiniz!", "Bir Hata Oluştu!", MessageType.ERROR))
        return false;
    };
}

export function getSpecificationType(specificationTypeId: string): ThunkResult<Promise<ISpecificationType | null>> {
    return async (dispatch, getState) => {
        const service = new SpecificationService();
        dispatch(toggleLoader());
        const response = await service.getSpecificationType(specificationTypeId);
        dispatch(toggleLoader());
        if (response.status === HttpStatusCode.OK) {
            const mapped = mapSpecificationTypeFromEntity(response.data.attributes["specificationType"] || {});
            // dispatch(initialPageData<ISpecificationType>(mapped));
            return mapped;
        }
        dispatch(showMessage("Bir hata oluştu. Servis sağlayıcınızla iletişime geçin ya da daha sonra tekrar deneyiniz!", "Bir Hata Oluştu!", MessageType.ERROR))
        return null;
    };
}

export function getSpecificationTypes(options: IListFilter): ThunkResult<Promise<boolean>> {
    return async (dispatch, getState) => {
        const service = new SpecificationService();
        dispatch(toggleLoader());
        const response = await service.getSpecificationTypes(options);
        dispatch(toggleLoader());
        if (response.status === HttpStatusCode.OK) {
            const mapped = (response?.data?.attributes?.list || []).map((item) =>
                mapSpecificationTypeFromEntity(item)
            );
            dispatch(setSpecificationTypes({
                list: mapped,
                pageSize: response.data.attributes.pageSize,
                totalCount: response.data.attributes.total,
                pageCount: Math.ceil(response.data.attributes.total / response.data.attributes.pageSize)
            }));
            return true;
        }
        return false;
    };
}

export function createSpecificationType(request: ISpecificationType): ThunkResult<Promise<ISpecificationType | null>> {
    return async (dispatch, getState) => {
        const service = new SpecificationService();
        dispatch(toggleLoader());
        const response = await service.createSpecificationType(mapSpecificationTypeFromEntity(request));
        dispatch(toggleLoader());
        if (response.status === HttpStatusCode.OK) {
            return mapSpecificationTypeFromEntity(response.data.attributes["specificationType"] || {});
        }
        return null;
    };
}

export function updateSpecificationType(request: ISpecificationType): ThunkResult<Promise<boolean>> {
    return async (dispatch, getState) => {
        const service = new SpecificationService();
        dispatch(toggleLoader());
        const response = await service.updateSpecificationType(mapSpecificationTypeFromModel(request));
        dispatch(toggleLoader());
        if (response.status === HttpStatusCode.OK) {
            return true;
        }
        return false;
    };
}

export function deleteSpecificationType(specificationTypeId: string): ThunkResult<Promise<boolean>> {
    return async (dispatch, getState) => {
        const service = new SpecificationService();
        dispatch(toggleLoader());
        const response = await service.deleteSpecificationType(specificationTypeId);
        dispatch(toggleLoader());
        if (response.status === HttpStatusCode.OK) {
            return true;
        }
        dispatch(showMessage("Bir hata oluştu. Servis sağlayıcınızla iletişime geçin ya da daha sonra tekrar deneyiniz!", "Bir Hata Oluştu!", MessageType.ERROR))
        return false;
    };
}